"use client";

// Third-party Imports
import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";

// Slice Imports
import entitySettingsReducer from "@/redux-store/slices/EntitySettings";
import userActivityReducer from "@/redux-store/slices/userActivity";
import userTeamsReducer from "@/redux-store/slices/userTeams";
import userNotificationsReducer from "@/redux-store/slices/userNotifications";
import manageEntityLoggingReducer from "@/redux-store/slices/ManageLogging";
import manageEntityUsersReducer from "@/redux-store/slices/ManageUsers";
import manageEntityTeamsReducer from "@/redux-store/slices/ManageTeams";
import moduleDevelopmentReducer from "@/redux-store/slices/Development";
import moduleElearningReducer from "@/redux-store/slices/Elearning";
import manageElearningReducer from "@/redux-store/slices/ManageElearning";

const rootReducer = combineReducers({
  entitySettingsReducer,
  userActivityReducer,
  userTeamsReducer,
  userNotificationsReducer,
  manageEntityLoggingReducer,
  manageEntityUsersReducer,
  manageEntityTeamsReducer,
  moduleDevelopmentReducer,
  moduleElearningReducer,
  manageElearningReducer,
});

const persistConfig = {
  key: "root",
  blacklist: [
    "userActivityReducer",
    "userTeamsReducer",
    "userNotificationsReducer",
    "manageEntityUsersReducer",
    "manageEntityLoggingReducer",
    "manageEntityTeamsReducer",
    "moduleDevelopmentReducer",
    "moduleElearningReducer",
    "manageElearningReducer",
  ],
  storage: storage,
  timeout: 1000,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({serializableCheck: false}),
  devTools: {
    maxAge: 50, // Limit to 50 actions in history
    actionSanitizer: (action: any) => {
      // Sanitize large payloads
      if (action.type?.includes('fulfilled') && action.payload) {
        return {
          ...action,
          payload: Array.isArray(action.payload) 
            ? `[Array(${action.payload.length})]` 
            : typeof action.payload === 'object'
            ? `[Object]`
            : action.payload
        };
      }

      
return action;
    },
    stateSanitizer: (state: any) => {
      // Sanitize large state objects
      return {
        ...state,

        // Reduce lesson data size in DevTools
        lesson: state.lesson ? {
          ...state.lesson,
          data: state.lesson.data ? '[Lesson Data]' : null
        } : state.lesson
      };
    }
  }
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
